<div class="dropdown-container" [class.full-width]="fullWidth" #dropdown>
  <div class="dropdown-label">{{ label }}</div>
  <div class="dropdown-selected dropdown-selected-frame" (click)="toggleDropdown()">
    {{ selectedLabel }}
    <span class="chevron" [class.open]="showOptions">&#9662;</span>
  </div>

  @if (showOptions == true) {
  <div class="contentbox">
    <div class="list">
      @for (option of options; track option.label; let idx = $index) {
        <div
          class="frame-61"
          (click)="selectOption(idx)"
      >
        <span class="custom-radio">
          @if (isMultichoice == true) {
            @if (option.selected == true) {
              <img class="checked" src="../../assets/checkbox.png" />
            } @else {
              <div class="unchecked"></div>
            }
          } @else {
            <span class="radio-outer" [class.selected]="option.selected"></span>
          }

        </span>
        <span class="option-label">{{ option.label }}</span>
      </div>
    }
    </div>
  </div>
}
</div>